import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function ConfirmBeforeDeleteDialog(props) {
  
  const parentOnProceed = props.onProceed?props.onProceed:() => {}
  const parentOnCancel = props.onCancel?props.onCancel:() => {}


  const handleCancel = () => {
    parentOnCancel()
  };

  const handleProceed = () => {
    parentOnProceed()
  };

  return (
    <React.Fragment>
    
      <Dialog
        open={props.open}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {props.title?props.title:"Confirm Delete"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please confirm you want to delete this record
          </DialogContentText>
          <props.list_element data={[props.data]}></props.list_element>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleProceed}>Delete</Button>
          <Button onClick={handleCancel} autoFocus>Cancel</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}